export type CertNameMode = 'short' | 'full'

export const CERT_NAME_MODE_STORAGE_KEY = 'cert_name_mode'
export const CERT_NAME_MODE_CHANGE_EVENT = 'cert-name-mode-change'

export type CertNameModeChangeDetail = {
  mode: CertNameMode
  pending: Promise<unknown>[]
}

let currentMode: CertNameMode | null = null

export const getCertNameMode = (): CertNameMode => {
  if (currentMode) return currentMode
  if (typeof window === 'undefined') return 'short'

  try {
    currentMode = localStorage.getItem(CERT_NAME_MODE_STORAGE_KEY) === 'full' ? 'full' : 'short'
  } catch {
    currentMode = 'short'
  }
  return currentMode
}

export const setCertNameMode = async (mode: CertNameMode): Promise<CertNameMode> => {
  if (typeof window === 'undefined') return 'short'

  try {
    localStorage.setItem(CERT_NAME_MODE_STORAGE_KEY, mode)
    currentMode = mode
  } catch {
    currentMode = 'short'
  }
  const detail: CertNameModeChangeDetail = { mode: currentMode, pending: [] }
  window.dispatchEvent(
    new CustomEvent<CertNameModeChangeDetail>(CERT_NAME_MODE_CHANGE_EVENT, { detail }),
  )
  await Promise.allSettled(detail.pending)
  return currentMode
}
